import * as React from "react";
import type { SVGProps } from "react";
const SvgSpotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="spot_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M785.92 128.939A158.805 158.805 0 0 1 901.12 281.6V320a43.52 43.52 0 0 1-87.04 0v-38.4a71.68 71.68 0 0 0-71.68-71.68H704a43.52 43.52 0 0 1-30.72-74.283l38.4-38.4a43.52 43.52 0 0 1 74.24 31.702zM263.253 679.168a312.32 312.32 0 1 1 416-416 43.52 43.52 0 0 1-13.952 54.016 312.363 312.363 0 1 1-348.16 348.16 43.52 43.52 0 0 1-53.888 13.824zm52.011-67.285A312.32 312.32 0 0 1 612.011 315.22a43.392 43.392 0 0 1-11.435-14.762 225.28 225.28 0 1 0-300.032 300.074c5.845 2.774 10.795 6.656 14.72 11.35zM852.437 627.2a225.28 225.28 0 1 0-450.517 0 225.28 225.28 0 0 0 450.56 0zm-729.6 76.8a43.52 43.52 0 0 1 87.04 0v38.4c0 39.595 32.128 71.68 71.68 71.68h38.4a43.52 43.52 0 0 1 30.806 74.283l-38.4 38.4a43.52 43.52 0 0 1-74.24-31.659A158.805 158.805 0 0 1 122.795 742.4V704z"
    />
  </svg>
);
export default SvgSpotIcon;
